import React, {FC} from 'react';

import {AppPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {VoiceBannerState} from '../../../store/panels/app/banners/bannersState';
import {ApplicationIncomingCallBannerContainer} from './applicationIncomingCallBannerContainer';

/*
 * Props.
 */

interface VoiceBannersProps {
  panelId: AppPanelId;
  banners: ReadonlyArray<VoiceBannerState>;
}

/*
 * Component.
 */

export const VoiceBanners: FC<VoiceBannersProps> = (props) => {
  const {panelId, banners} = props;

  return (
    <>
      {banners.map((banner) => (
        <ApplicationIncomingCallBannerContainer key={banner.uid} panelId={panelId} bannerState={banner} />
      ))}
    </>
  );
};
